export default "assets/images/blason-7a1df37e.png";